// src/features/services/components/ServiceTable.tsx
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { Service } from '../types/service.types';
import { ServiceStatusBadge } from './ServiceStatusBadge';

export interface ServiceTableProps {
  services: Service[];
}

/**
 * Service list table. Presentation only — takes real API rows as a
 * prop and has no data-source or mock dependency.
 * Same shape as customers/components/CustomerTable.tsx: wrapped in
 * the shared glass-card `Card` primitive (noPadding, table owns its
 * own cell padding) with a horizontal-scroll rail for narrow
 * viewports.
 *
 * Rows are clickable and call navigate(`/services/${service.id}`),
 * which now resolves to the ServiceWorkspacePage foundation route.
 */
export function ServiceTable({ services }: ServiceTableProps) {
  return (
    <div className="vania-services-table-scroll">
        <table className="vania-services-table">
          <thead>
            <tr>
              <th>نام سرویس</th>
              <th>تننت</th>
              <th>شناسه</th>
              <th>نوع</th>
              <th>وضعیت</th>
              <th>تاریخ ایجاد</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {services.map((service) => (
              <tr
                key={service.id}
                className="vania-services-table-row"
              >
                <td className="vania-services-table-name">{service.name}</td>
                <td>{formatPersianNumber(service.tenant_id)}</td>
                <td>{service.slug}</td>
                <td>{service.type}</td>
                <td>
                  <ServiceStatusBadge status={service.status} />
                </td>
                <td dir="ltr">{formatSolarDate(service.created_at)}</td>
                <td><Link className="vania-services-row-action" to={`/services/${service.id}`} aria-label="مشاهده سرویس" title="مشاهده"><Eye size={14} aria-hidden="true" /><span className="sr-only">مشاهده</span></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
    </div>
  );
}
